































































































































































































import { Component, Prop } from 'vue-property-decorator';
import { VuetifyConfirmObject } from 'vuetify-confirm';
import SaascadaVueFieldGroup from '@/components/Shared/SaascadaVueForm';
import { LendingAccountModule } from '@/store/Accounts/LendingAccountModule';
import AccountLendingInterestSettings from '@/models/Accounts/LendingAccounts/Ledgers/Settings/LendingInterest/AccountLendingInterestSettings';
import AccountLendingInterestSettingsEditDialog from '@/components/Accounts/LendingAccounts/Ledgers/Settings/LendingInterest/AccountLendingInterestSettingsEditDialog.vue';
import SimulatedField from '@/components/Accounts/Shared/SimulatedField.vue';
import InterestRateType from '@/models/Products/InterestRateType';
import PeriodType from '@/models/Shared/PeriodType';
import PermissionUtils from '@/lib/permissionUtils';

@Component({ name: 'AccountLendingInterestSettingsRead', components: { AccountLendingInterestSettingsEditDialog, SimulatedField } })
export default class extends SaascadaVueFieldGroup {

    InterestRateType = InterestRateType;
    PeriodType = PeriodType;
    PermissionUtils = PermissionUtils;

    @Prop({required: true })
    settings: AccountLendingInterestSettings;

    get simulatedRateType() {
        const simulationSettingsChanges = LendingAccountModule.simulation.lendingSettingsChanges;
        const simulatedRateType = simulationSettingsChanges.find((setting) => {
            return setting.key === 'rateType';
        });

        if (simulatedRateType) {
            return simulatedRateType.value;
        }
        else {
            return;
        }
    }

    get simulatedRateValue() {
        const simulationSettingsChanges = LendingAccountModule.simulation.lendingSettingsChanges;
        const simulatedRateValue = simulationSettingsChanges.find((setting) => {
            return setting.key === 'rateValue';
        });

        if (simulatedRateValue) {
            return `${simulatedRateValue.value}%`;
        }
        else {
            return;
        }
    }

    get rateSourceRate() {
        // This is not currently provided in the API so calculate it manually
        return this.settings.cumulativeRateValue - this.settings.rateValue;
    }

    get cumulativeRateCalculationText() {
        // A text representation of the cumulative rate calculation
        return `${this.settings.rateSourceIdentifier.entityName} ${this.rateSourceRate}% + ${this.$t('pageText.products.fields.rateValue')} ${this.settings.rateValue}%`;
    }

    async deleteDepositInterestAccountSettings() {
        const options: VuetifyConfirmObject = {
            buttonTrueText: "Delete",
            buttonFalseText: "Close",
            buttonTrueColor: "primary",
            buttonFalseColor: "primary",
        }
        const result = await this.$confirm('Are you sure you want to delete the overridden account settings?', options);
        if (result) {
            await LendingAccountModule.deleteLendingInterestSettings();
        }
    }

}
